"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TAG_TYPES = void 0;
exports.TAG_TYPES = Object.freeze({
    tag: 'tag',
    category: 'category'
});
//# sourceMappingURL=tagTypes.js.map